const DATA_URL_REGEX = /^\s*data:([a-z]+\/[a-z0-9-+.]+(;[a-z-]+=[a-z0-9-]+)?)?(;base64)?,([a-z0-9!$&',()*+;=\-._~:@/?%\s]*)\s*$/i;

// Remove data URLs
export const purify = (name, val) => {
  if (typeof val === 'string' && val.match(DATA_URL_REGEX)) {
    // Filtering out data urls
    return undefined;
  }

  return val;
};



// WEBPACK FOOTER //
// ./src/utils/json.js